import React, { useState, useEffect } from 'react';
import {
    Typography, Grid, Button, FormControl, Container,
    Card, InputLabel, OutlinedInput, InputAdornment, IconButton
} from '@mui/material';
import styleForm from '../Tool/Style';
import { useStateValue } from '../../Contexto/store';
import DiccionarioEtiquetas from '../../Configuracion/Idiomas/Etiquetas_Diccionario';
import { enlistaArrayCodigosMensajesIdiomas } from '../../Actions/Generales/IdiomasAction';
import { obtenerPoliticasContrasena } from '../../Actions/Generales/PoliticasContrasenaAction';
import { withRouter } from 'react-router-dom';
import ImgLogin from '../../Activos/Imagenes/LogoClassLimitless.svg';
import { styleLogin } from '../Tool/Style';
import { useHistory, useParams  } from "react-router-dom";
import { validaTokenCambioContrasena, realizaCambioContrasena, desactivaTokenCambioContrasena } from '../../Actions/Usuarios/UsuarioAction';
import { LlavesConfiguraciones } from "../../Configuracion/Llaves/RepositorioConfig";
import { HtmlTooltip } from '../ControlUsuario/TooltipHtml';
import { ListaPoliticasContrasena } from '../ControlUsuario/PoliticasContrasenas';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';

import { MostrarMensaje } from '../../Utilidades/ManejoMensajes';

const CambioContrasena = () => {

    const history = useHistory();
    const params = useParams();

    const IdToken = params.controlchangeid;

    //se accede al storage para ver la variable de sesion de usuario
    // contexto de variables globales con el Context Api 
    const [{ etiquetasIdioma }, dispatch] = useStateValue();

    const [newPassword, SetNewPassword] = useState('');
    const [confirmPass, SetConfirm] = useState('');
    const [validarToken, SetValidarToken] = useState(true);
    const [usuarioId, SetUsuarioId] = useState('');
    const [showNewPassword, SetShowNewPassword] = useState(false);
    const [showConfirmPass, SetShowConfirmPass] = useState(false);

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    const regresarPaginaLogin = (e) => {
        e.preventDefault();
        IrPaginaLogin();
    }

    const IrPaginaLogin = () => {
        history.push(LlavesConfiguraciones.rutaPublicacion + "/auth/login");
    }

    const validarTokenCambioPass = async () => {
        SetValidarToken(false);
        dispatch({ type: "LOAD_COMP", texto: etiquetas.EtiquetasComponente.CargandoModal.Et_Procesando });

        const responseUsuario = await validaTokenCambioContrasena(IdToken);
        
        if (responseUsuario?.status === 200) //si la respuesta fue existosa
        {            
            SetUsuarioId(responseUsuario?.data);
            dispatch({ type: "CLOSE_LOAD_COMP" });           
        }
        else {
            dispatch({ type: "CLOSE_LOAD_COMP" });            
            if (responseUsuario.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseUsuario.data.errors);
                MostrarMensaje(dispatch, responseUsuario.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [responseUsuario.statusText]);
            }
            IrPaginaLogin();
        }

    }

    useEffect(() => {
        inicializar();
    }, []);

    const inicializar = async () => {
        if (validarToken) {
            await validarTokenCambioPass();
        }
        await BuscaPoliticasContrasenas();
    }

    const [PoliticasContrasenas, setPoliticasContrasenas] = useState({
        ppoMinimumCharacters: 0,
        ppoMaximumCharacters: 0,
        ppoPasswordHistory: 0,
        ppoValidity: 0,
        ppoAllowsNumbers: false,
        ppoAllowsVowels: false,
        ppoCapitalLetter: false,
        ppoLowercaseLetter: false,
        ppoSpecialCharacter: false
    });

    const BuscaPoliticasContrasenas = async () => {        
        const objectRequest = {
        };

        const response = await obtenerPoliticasContrasena(objectRequest);

        if (response.status === 200) { //si la respuesta fue existosa
            // se asigna al objeto de variable de estado local la respuesta
            setPoliticasContrasenas(response.data);
        }
    };

    const cambiarPassword = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPass) {
            MostrarMensaje(dispatch, 'error', ["ErrorConfirmPassw"]);
        }
        else {
            dispatch({ type: "LOAD_COMP", texto: etiquetas.EtiquetasComponente.CargandoModal.Et_Procesando });

            const responseUsuario = await realizaCambioContrasena(usuarioId, newPassword, confirmPass);            
           
            if (responseUsuario?.status === 200) //si la respuesta fue existosa
            {
                MostrarMensaje(dispatch, 'success', ["ChangePasswOK"]);
                await desactivaTokenCambioContrasena(IdToken);
                dispatch({ type: "CLOSE_LOAD_COMP" });
                IrPaginaLogin();
            }
            else {
                dispatch({ type: "CLOSE_LOAD_COMP" });
                if (responseUsuario.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseUsuario.data.errors);
                    MostrarMensaje(dispatch, responseUsuario.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [responseUsuario.statusText]);
                }
            }
        }
        
    };


    const functionMostrarDetallePoliticasContrasena = () => {
        return (            
            <ListaPoliticasContrasena claveNueva={newPassword} claveConfirma={confirmPass} PoliticasContrasenas={PoliticasContrasenas} />            
        );
    }


    return (
        <Container maxWidth="sm" justify="center" spacing={0} style={styleLogin.conteiner}>
            <Card style={{ ...styleLogin.divForm, ...{ padding: '3rem' } }}>
                <div style={styleForm.paper}>
                    <img src={ImgLogin} alt={"Imagen de Registro"} />
                    <Typography variant="subtitle2" style={{ fontSize: 16, paddingTop: 25 }}>
                        {etiquetas.EtiquetasComponente.CambiarContrasena.Et_TituloPrincipal}
                    </Typography>
                </div>
                <form style={styleForm.form}>
                    <Grid container spacing={2} style={{ backgroundColor: 'transparent' }}>                        
                        <Grid item xs={12} >
                            {/*<TextField name="password" variant="outlined" fullWidth label={etiquetas.EtiquetasComponente.CambiarContrasena.Et_txtContrasena}*/}
                            {/*    value={newPassword} onChange={(e) => SetNewPassword(e.target.value)} />*/}

                            <HtmlTooltip                                
                                title={
                                    <div style={{ width:  '100%' }}>
                                        {functionMostrarDetallePoliticasContrasena()}
                                    </div>
                                }
                            >
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel htmlFor="outlined-adornment-password">{etiquetas.EtiquetasComponente.CambiarContrasena.Et_txtContrasena}</InputLabel>
                                    <OutlinedInput
                                        autoComplete="off"
                                        name="password"
                                        id="outlined-adornment-password"
                                        type={showNewPassword ? 'text' : 'password'}
                                        value={newPassword}
                                        onChange={(e) => SetNewPassword(e.target.value)}                                    
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={(e) => SetShowNewPassword(!showNewPassword)}
                                                    edge="end"
                                                >
                                                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label={etiquetas.EtiquetasComponente.CambiarContrasena.Et_txtContrasena}
                                        inputProps={{
                                            maxLength: 50
                                        }}
                                    />                                
                                </FormControl>
                            </HtmlTooltip>
                        </Grid>                        
                        <Grid item xs={12} >
                            {/*<TextField name="confirm" variant="outlined" fullWidth label={etiquetas.EtiquetasComponente.CambiarContrasena.Et_txtConfirmar}*/}
                            {/*    value={confirmPass} onChange={(e) => SetConfirm(e.target.value)} />*/}

                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-adornment-password">{etiquetas.EtiquetasComponente.CambiarContrasena.Et_txtConfirmar}</InputLabel>
                                <OutlinedInput
                                    autoComplete="off"
                                    name="confirm"
                                    id="outlined-adornment-password"
                                    type={showConfirmPass ? 'text' : 'password'}
                                    value={confirmPass}
                                    onChange={(e) => SetConfirm(e.target.value)}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={(e) => SetShowConfirmPass(!showConfirmPass)}
                                                edge="end"
                                            >
                                                {showConfirmPass ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label={etiquetas.EtiquetasComponente.CambiarContrasena.Et_txtConfirmar}
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} style={{ textAlign: 'center' }} >
                            <HtmlTooltip
                                title={
                                    <div style={{ width: '100%' }}>
                                        {functionMostrarDetallePoliticasContrasena()}
                                    </div>
                                }
                            >
                                <div style={{ width: '100%', display: 'inline-block', textAlign: 'center' }}>
                                    <PrivacyTipIcon sx={{ fontSize: '20px', marginRight: '2px', marginBottom: '-3px', display: 'inline-block' }} />
                                    <Typography variant="body1" style={{ fontSize: 16, display: 'inline-block' }}>
                                        {etiquetas.EtiquetasComponente.CambiarContrasena.Et_Cuerpo}
                                    </Typography>
                                </div>
                            </HtmlTooltip>
                        </Grid>
                        <Grid item xs={12} >
                            <Button fullWidth variant="contained" style={styleForm.submit} color="primary" size="large" onClick={cambiarPassword}>{etiquetas.EtiquetasComponente.CambiarContrasena.Et_BotonAccion}</Button>
                        </Grid>
                        <Grid item xs={12} >
                            <Button
                                fullWidth
                                variant="contained"
                                style={styleForm.submit}
                                size="large"
                                onClick={regresarPaginaLogin}>{etiquetas.EtiquetasComponente.CambiarContrasena.Et_BotonRegresar}</Button>
                        </Grid>
                    </Grid>
                </form>
            </Card>
        </Container>
    );
};

export default withRouter(CambioContrasena);